import { render, staticRenderFns } from "./RankingHeader.vue?vue&type=template&id=14baae3c&scoped=true"
import script from "./RankingHeader.vue?vue&type=script&lang=js"
export * from "./RankingHeader.vue?vue&type=script&lang=js"
import style0 from "./RankingHeader.vue?vue&type=style&index=0&id=14baae3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14baae3c",
  null
  
)

export default component.exports